import { connect } from 'react-redux';

import Device from '../../components/sider/device';

export default connect()(Device);



// WEBPACK FOOTER //
// ./containers/sider/device.js